import { z } from 'zod';
import { College } from '../../entities/user';

export const CampusResourceSchema = z.object({
    _id: z.string(),
    title: z.string(),
    university: z.nativeEnum(College),
    link: z.string().url(),
    order: z.number().int().min(0),
    createdAt: z.string(),
    updatedAt: z.string(),
});

export const CampusResourceResponseSchema = z.object({
    resource: CampusResourceSchema,
});

export const CampusResourcesListResponseSchema = z.object({
    resources: z.array(CampusResourceSchema),
});

// Input schema for getting resources by university
export const GetCampusResourcesByUniversityInputSchema = z.object({
    university: z.nativeEnum(College).optional(),
});
